import { Menu, MenuItem } from '@blueprintjs/core';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import { useClearDiagram } from 'src/containers/ProjectDiagram/hooks/useClearDiagram';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { MappingLink } from 'src/containers/ProjectDiagram/types/diagram';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { removeMapping } from 'src/containers/ProjectDiagram/utils/mapping/removeMapping';
import * as copy from 'src/templates/copy';
import { useNavigateMapping } from 'src/utils/hooks/useNavigateMapping';

type MappingContextMenuProps = {
  link: MappingLink;
};

export const MappingContextMenu: React.VFC<MappingContextMenuProps> = ({
  link,
}) => {
  const diagram = useDiagram();
  const clearDiagram = useClearDiagram();

  const navigateMapping = useNavigateMapping();
  const handleSelectMapping = React.useCallback(() => {
    if (!link) {
      return;
    }
    navigateMapping(link.data.value);
  }, [link, navigateMapping]);

  return (
    <Menu>
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.mapping}
        onClick={handleSelectMapping}
        text={copy.components.projectDiagram.contextMenu.mapping}
      />
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.delete}
        onClick={() => {
          if (!diagram || !link) {
            return;
          }

          clearDiagram();
          commitDiagramModel(diagram, removeMapping(link.data));
        }}
        text={copy.components.projectDiagram.contextMenu.delete}
      />
    </Menu>
  );
};
